export const NEXT_RESET_DATE_CONTROL = 'next-reset-date-control';
export const NEXT_RESET_DATE_REQUIRED_ERROR = 'next-reset-date-required-error';
export const NEXT_RESET_DATE_REQUIRED_MESSAGE = 'Next Reset Date is required field';
